import { useState, useEffect } from 'react'
import { privatenotes } from '../../../services/data'
import { toast, ToastContainer } from 'react-toastify'
import { useLocation, useParams } from 'react-router-dom'

const AddPrivateNotes = ({ closePopup, ticketid, refreshNotes }) => {
  const [text, setText] = useState('')
  const [loading, setLoading] = useState(false)
  const wordLimit = 500

  const location = useLocation()
  const params = useParams()
  
    // ✅ Extract store_id from URL (params or pathname)
    const getStoreIdFromUrl = () => {
      if (params?.store_id) return params.store_id
      const pathParts = location.pathname.split('/')
      console.log(pathParts[1])
      return pathParts[1] || null
    }
  
    const storeid = getStoreIdFromUrl()

  // Reset text when ticketid changes
  useEffect(() => {
    setText('')
  }, [ticketid])

  const handleChange = e => {
    const inputText = e.target.value
    if (inputText.length <= wordLimit) {
      setText(inputText)
    }
  }

  const handleSaveNote = async () => {
    if (!text.trim()) {
      return toast.error('Note cannot be empty', {
        position: 'bottom-center',
        toastId: 'empty-note'
      })
    }

    setLoading(true)

    try {
      const noteData = {
        ticket_id: ticketid,
        store_id: storeid || '',
        ticket_notes: text,
        meta: {}
      }

      const response = await new privatenotes().createNote(noteData)

      if (response?.success) {
        setText('')
        await refreshNotes(ticketid) // Ensure we refresh for the correct ticket
        closePopup()
        toast.success(response.message, {
          position: 'bottom-center',
          toastId: 'note-success'
        })
      } else {
        toast.error(response?.message || 'Failed to add note', {
          position: 'bottom-center',
          toastId: 'note-error'
        })
      }
    } catch (error) {
      console.error('Error saving note:', error)
      toast.error('Error saving note', {
        position: 'bottom-center',
        toastId: 'note-exception'
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[100] p-5'>
      <div
        className='bg-white shadow-lg w-full max-w-[850px] mx-auto my-[30px] rounded-[24px] border border-white overflow-y-auto min-h-[40%] max-h-[99%] h-[298px] scrollbar-hide'
        style={{ boxShadow: '-1px 0px 0px 0px #DFE5F1 inset' }}
      >
        {/* Top Header */}
        <div className='flex sticky top-0 bg-[#F1F1F1] w-full py-5 items-center px-5 justify-between border-[#E5E9EB] z-10'>
          <h2 className='text-[19px] font-bold'>Add Note</h2>
          <button
            className='w-[30px] h-[30px] flex justify-center items-center rounded-full text-white text-[14px] cursor-pointer'
            aria-label='Close'
            onClick={closePopup}
          >
            <svg
              width='30'
              height='30'
              viewBox='0 0 30 30'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M9.1 7.77c-.37-.37-.96-.37-1.33 0s-.37.96 0 1.33L13.67 15l-5.9 5.9c-.37.37-.37.96 0 1.33s.96.37 1.33 0L15 16.33l5.9 5.9c.37.37.96.37 1.33 0s.37-.96 0-1.33L16.33 15l5.9-5.9c.37-.37.37-.96 0-1.33s-.96-.37-1.33 0L15 13.67l-5.9-5.9z'
                fill='#000000'
              />
            </svg>
          </button>
        </div>

        {/* Text area */}
        <div className='p-5 relative'>
          <textarea
            className='w-full min-h-[100px] border border-gray-300 rounded-lg p-3 resize-none focus:outline-none'
            value={text}
            onChange={handleChange}
            placeholder='Write your notes here...'
            required
          />
          <div className='text-gray-500 text-sm text-right mt-2 absolute bottom-7 right-7'>
            {text.length} / {wordLimit}
          </div>
        </div>

        {/* Bottom Buttons */}
        <div className='flex sticky bottom-0 bg-[#FFFFFF] w-full py-5 items-center px-5 justify-end gap-2 border-t-[1px] border-[#E5E9EB] z-10'>
          <button
            onClick={closePopup}
            className='rounded-[59px] border-[1px] border-[#DEDEDE] text-[14px] p-[10px] w-[85px] h-[39px] hover:bg-gray-50 transition-colors'
          >
            Cancel
          </button>
          <button
            onClick={handleSaveNote}
            disabled={loading || !text.trim()}
            className='w-[85px] h-[39px] rounded-[59px] text-white text-[14px] bg-[#7C50DD] disabled:bg-gray-400 hover:bg-[#6a40c5] transition-colors'
          >
            {loading ? (
              <span className='inline-flex items-center justify-center'>
                <svg
                  className='animate-spin -ml-1 mr-1 h-4 w-4 text-white'
                  xmlns='http://www.w3.org/2000/svg'
                  fill='none'
                  viewBox='0 0 24 24'
                >
                  <circle
                    className='opacity-25'
                    cx='12'
                    cy='12'
                    r='10'
                    stroke='currentColor'
                    strokeWidth='4'
                  ></circle>
                  <path
                    className='opacity-75'
                    fill='currentColor'
                    d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
                  ></path>
                </svg>
                Saving
              </span>
            ) : (
              'Save'
            )}
          </button>
        </div>
      </div>
      <ToastContainer containerId={'addnotes'} />
    </div>
  )
}

export default AddPrivateNotes
